// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Zambia */
const ZM = /^(?:(?:[59][5-8]|7[5-9])\d{7})$/;

export default ZM;
